import { AsyncPipe, DatePipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { MatTab, MatTabContent, MatTabGroup } from '@angular/material/tabs'
import {
  ElderBasicPaneLayoutComponent,
  ElderPaneComponent,
  ElderTabDirective,
  ElderTabGroupRoutingDirective,
  ElderToolbarColumnDirective,
} from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { Observable } from 'rxjs'
import { FacilityContextMenuComponent } from '../../../../context/facility-context/facility-context-menu/facility-context-menu.component'
import { IntervalContextMenuComponent } from '../../../../context/interval-context/interval-context-menu/interval-context-menu.component'
import { MexusContext, MexusContextService } from '../../../../context/mexus-context.service'
import { MexusViewMode } from '../../../../context/view-mode-context/mexus-view-mode'
import { ViewModeContextMenuComponent } from '../../../../context/view-mode-context/view-mode-context-menu/view-mode-context-menu.component'
import { UtilizationReportTableComponent } from '../../../../reports/workcenter-utilization/utilization-report-table/utilization-report-table.component'
import { WorkOrderBrowserComponent } from '../../../work-orders/work-order-browser/work-order-browser.component'
import { FacilityUtilisationDetailComponent } from '../facility-utilisation-detail/facility-utilisation-detail.component'

@Component({
  selector: 'app-schedule-overview',
  templateUrl: './schedule-overview.component.html',
  styleUrls: ['./schedule-overview.component.scss'],
  imports: [
    ElderToolbarColumnDirective,
    ViewModeContextMenuComponent,
    FacilityContextMenuComponent,
    IntervalContextMenuComponent,
    MatTabGroup,
    ElderTabGroupRoutingDirective,
    MatTab,
    ElderTabDirective,
    MatTabContent,
    FacilityUtilisationDetailComponent,
    WorkOrderBrowserComponent,
    UtilizationReportTableComponent,
    AsyncPipe,
    DatePipe,
    ElderTranslatePipe,
    ElderBasicPaneLayoutComponent,
    ElderPaneComponent,
  ],
})
export class ScheduleOverviewComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly activeContext$: Observable<MexusContext>
  public readonly ViewMode = MexusViewMode

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const mexusContextService = inject(MexusContextService)
    this.activeContext$ = mexusContextService.activeContext$
  }
}
